


































































import firebase from "firebase";
import { Component, Vue } from "vue-property-decorator";
import SoundManager from "../soundManager";
const VueProps = Vue.extend();
@Component<GameEnd>({})
export default class GameEnd extends VueProps {
  public canvas!: HTMLCanvasElement;
  
  public save(): void {
    SoundManager.btnSound();
    firebase.analytics().setCurrentScreen("save");
    firebase.analytics().logEvent("screen_view");
    console.log("save");
    this.$emit("save");
  }
  public replay(): void {
    SoundManager.btnSound();
    firebase.analytics().setCurrentScreen("replay");
    firebase.analytics().logEvent("screen_view");
    console.log("replay");
    this.$emit("replay");
  }
  private shareURL = "";

  public async shareImage(): Promise<void> {
    firebase.analytics().setCurrentScreen("share");
    firebase.analytics().logEvent("screen_view");
    if (this.shareURL == "") return;
    const shareData = {
      title: "HOLD YOUR FART!",
      text: this.shareURL,
      url: this.shareURL,
    };
    try {
      await navigator.share(shareData);
    } catch (err) {
      //alert("Sharing does not supported.");
    }
  }
  public saveImage() {
    /*var uri = this.canvas.toDataURL("image/png").replace("image/png", "octet/stream");
    var a: any = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = uri;
    a.download = "nobc.png";
    a.click();
    window.URL.revokeObjectURL(uri);
    document.body.removeChild(a);*/
    //const win = window.open(uri, '_blank');
    var w: any = window.open("", "");
    w.document.title = "Screenshot";
    //w.document.body.style.backgroundColor = "red";
    var img = new Image();
    // Without 'preserveDrawingBuffer' set to true, we must render now
    //this.renderer.render(this.scene, this.camera);
    img.src = this.canvas?.toDataURL("image/png");
    w.document.body.appendChild(img);
  }
  public targetImageData: any;
  public setImage(
    data: any,
    ccNum: number,
    cc: string,
    date: string,
    frame: any
  ) {
    this.gameData.cc = cc + " cc";
    this.gameData.ccNum = ccNum;
    this.gameData.date = date;
    this.targetImageData = data;
    this.makeImage(data, frame);
    var i: any = this.$refs.imgg;
    i.src = this.canvas?.toDataURL("image/png");
    this.$emit("score", this);
  }

  mounted() {
    this.canvas = document.createElement("canvas");
    this.canvas.width = 700;
    this.canvas.height = 700;
    this.shareURL = "";
  }

  makeImage(data: any, frame: any) {
    var newCanvas: any = this.canvas;

    var ctx = newCanvas.getContext("2d");
    ctx.fillStyle = "red";
    ctx.fillRect(0, 0, newCanvas.width, newCanvas.height);

    ctx.strokeStyle = "#FFFFFF";

    ctx.drawImage(data, 0, 0, 730, 730);
    ctx.drawImage(frame, 40, 40, 150, 168);
    

    ctx.fillStyle = "rgba(0, 0, 0, 1)";
    
    ctx.font = "40px BMKIRANGHAERANG";
    ctx.fillText("greenplay.online", 430, 60);

    ctx.font = "40px SingleDay, SDMiSaeng";
    ctx.fillText(this.gameData.date, 40, 615);
    ctx.textAlign = "right";
    ctx.fillText(this.gameData.cc, 657, 663);
    ctx.font = "45px SingleDay, SDMiSaeng";
    ctx.textAlign = "left";
    ctx.fillText(this.gameData.name, 40, 660);
    
  }
  public gameData = {
    ccNum: 0,
    cc: "0cc",
    date: "2021/01/01",
    name:"test"
  };
}
